import React from 'react';

import {Partners} from '../../components';

export default Partners;


// WEBPACK FOOTER //
// ./src/pages/partners/index.js